<div class="flex flex-col md:flex-row gap-2">
  <div>
    <app-suspect-image [cancellationId]="cancellationId()"></app-suspect-image>
  </div>

  <div class="flex-1">
    @if (loadingData) {
      <mat-progress-spinner mode="indeterminate" class="m-0 mt-5"></mat-progress-spinner>
    }

    <div class="mat-typography relative">
      <div class="text-lg bold text-center md:text-left">Cancelled Items</div>
      <mat-divider></mat-divider>
      @if (items.length === 0) {
        <p>No cancelled items found</p>
      }

      <ol>
        @for (item of items; track i; let i = $index) {
          <li class="mb-1.5">
            {{ formatCancellationItem(item) }}
          </li>
        }
      </ol>
    </div>
  </div>
</div>
